import {
  IonItem,
  IonList, IonSkeletonText
} from '@ionic/react';
import React from "react";

export const SkeletonText= ({ isVisible }) => {
  if (!isVisible) return null

  return (
      <IonList>
        <IonItem>
          <div style={{border: 'none'}}>
            <IonSkeletonText animated style={{ width : '80%' }} />
          </div>

          <div style={{display: "inherit"}}>
            <IonSkeletonText animated style={{ width : '100%' }} />
          </div>
        </IonItem>

        <IonItem>
          <div style={{border: 'none'}}>
            <IonSkeletonText animated style={{ width : '80%' }} />
          </div>

          <div style={{display: "inherit"}}>
            <IonSkeletonText animated style={{ width : '100%' }} />
          </div>
        </IonItem>
      </IonList>
  )
}